import { getLogoutUseCase } from '@/di';

/**
 * Servicio específico para manejo de logout
 * Cumple con SRP: única responsabilidad es orquestar el logout
 * Capa correcta para acceder a DI - respeta Clean Architecture
 */
class AuthLogoutService {
  /**
   * Ejecuta el proceso completo de logout
   * @param reason - Razón del logout para logging y UX
   */
  async logout(
    reason?: 'manual' | 'token_expired' | 'token_invalid',
  ): Promise<void> {
    await getLogoutUseCase().execute(reason);
  }
}

export const authLogoutService = new AuthLogoutService();
